import React from 'react'
import LocationBoxes from '../components/LocationsBoxes/v3/LocationBoxes'

export default function LocationBoxesV3(props) {
  const {
    // businessData,
    // configData,
    // pageTitle,
    // gonationID,
    // locationIndex,
    variantName
    // options,
  } = props

  const variant = variantName ? variantName : 'locationBoxesV3'

  return <LocationBoxes {...props} variantName={variant} />
}
